/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_DescriptionInputs */



/**
* | output |
* | --- |
* | "Edit event group settings and properties" |
*
* @param {Edit_Event_Group_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_description = /** @type {((inputs?: Edit_Event_Group_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier les paramètres et propriétés du groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen und Eigenschaften der Ereignisgruppe bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica le impostazioni e le proprietà del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактирование настроек и свойств группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar la configuración y las propiedades del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑事件组设置和属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループの設定とプロパティを編集する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह की सेटिंग्स और प्रॉपर्टीज़ को संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar configurações e propriedades do grupo de eventos")
	return /** @type {LocalizedString} */ ("Edit event group settings and properties")
});